// extracted by mini-css-extract-plugin
export default {"mySelectArrow":"select_mySelectArrow__2Vxf3"};